import React, { useEffect, ReactNode } from 'react';
import Button from './Button/Button';
import { isMobile } from 'react-device-detect';

interface ModalProps {
  isOpen: boolean;
  title?: string;
  content?: ReactNode;
  onClose: () => void;
  children: React.ReactNode;
  modalBg?: string;
}

const ExpModal: React.FC<ModalProps> = ({ isOpen, title, content, onClose, children, modalBg = "bg-white" }) => {
  const titles=[
    "Do you wish to perform cash out?",

  ]
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    } else {
      document.removeEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[100] bg-black bg-opacity-50 flex items-center justify-center"
      onClick={onClose}
    >
      <div
        className={`${modalBg} rounded-lg shadow-lg w-[80%] max-h-[80vh] overflow-hidden px-4 py-3 relative`}
        style={{ width: isMobile?"90vw": '40vw' }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header Section - Static */}
        <div className={`sticky top-0 left-0   text-white right-0 bg-inherit z-10 flex justify-between items-center border-b pb-3`}>
          <h2 className="text-xl font-semibold ">{title}</h2>
          <Button onClick={onClose} className=" hover:text-gray-500 text-gray-950 ">
            <svg
              className="w-6 h-6"
              fill="black"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                fill='black'
                d="M6 18L18 6M6 6l12 12"
              ></path>
            </svg>
          </Button>
        </div>

        {/* Scrollable Content */}
        <div className="py-4 overflow-y-auto max-h-[70vh]">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ExpModal;
